import { useMemo } from 'react';

import { useCatalogs } from 'hooks';

import { isWeekday, convertDate } from 'utils/date';

const useBusinessDayFilter = (countryCurrency?: string | null) => {
  const { daysInactive } = useCatalogs();

  const inactiveDatesSet = useMemo(() => {
    if (!countryCurrency || !daysInactive?.values?.length) {
      return null;
    }

    return new Set(
      daysInactive.values
        .filter((day) => day.code02 === countryCurrency)
        .map((day) => day.value),
    );
  }, [daysInactive, countryCurrency]);

  const filterBusinessDays = useMemo(() => {
    if (!countryCurrency) {
      return (date: Date) => isWeekday(date);
    }

    return (date: Date): boolean => {
      if (!isWeekday(date)) return false;
      if (!inactiveDatesSet) return true;

      return !inactiveDatesSet.has(convertDate(date, 'yyyy-MM-dd'));
    };
  }, [countryCurrency, inactiveDatesSet]);

  return filterBusinessDays;
};

export default useBusinessDayFilter;
